


<template>
  <!-- 图片导航栏 -->
  <div class="page">
    <div class="flex container imageDiv" :class="{ 'imageDiv--compact': formatCategory.length <= 4 }">
      <!-- flex-1 -->
      <div v-for="(item, index) in formatCategory" :key="index" class="t-a-c imageDivItem" @click="goClass(item)">
        <img :src="item.icon" alt="" class="img" />
        <div class="divText">{{ item.name }}</div>
      </div>
    </div>
    <!-- 下部分轮播显示 -->
    <div
      v-if="bottomCategory.length > 0 && bottomCategory[0].length > 0 && bottomCategory[0][0].length > 0"
      class="category-swipe-wrap"
    >
      <van-swipe @change="onChange" :loop="false" class="category-swipe" ref="mySwipe" :duration="duration">
        <van-swipe-item>
          <div class="category-swipe-page">
            <div class="flex container2">
              <div v-for="(item, index) in bottomCategory[0][0]" :key="index" class="imageDivItem t-a-c"
                @click="goClass(item)">
                <img :src="item.icon" alt="" class="img" />
                <div class="divText">{{ item.name }}</div>
              </div>
            </div>
            <div v-if="bottomCategory[0][1].length > 0" class="flex container2">
              <div v-for="(item, index) in bottomCategory[0][1]" :key="index" class="imageDivItem t-a-c"
                @click="goClass(item)">
                <img :src="item.icon" alt="" class="img" />
                <div class="divText">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item v-if="bottomCategory[1][0].length > 0">
          <div class="category-swipe-page">
            <div class="flex container2">
              <div v-for="(item, index) in bottomCategory[1][0]" :key="index" class="imageDivItem t-a-c"
                @click="goClass(item)">
                <img :src="item.icon" alt="" class="img" />
                <div class="divText">{{ item.name }}</div>
              </div>
            </div>
            <div v-if="bottomCategory[1][1].length > 0" class="flex container2">
              <div v-for="(item, index) in bottomCategory[1][1]" :key="index" class="imageDivItem t-a-c"
                @click="goClass(item)">
                <img :src="item.icon" alt="" class="img" />
                <div class="divText">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </van-swipe-item>
        <template #indicator>
          <ul class="indicators" v-if="bottomCategory[1][0].length > 0">
            <li class="indicator" v-for="(item, index) in bottomCategory" :key="index"
              :class="{ active: checkActive(index) }"></li>
          </ul>
        </template>
      </van-swipe>
    </div>

    <!-- 自定义弹窗 -->
    <CustomDialog
      :visible.sync="showCustomDialog"
      title="温馨提示"
      :message="dialogMessage"
      confirm-text="已知晓"
      cancel-text="取消"
      @confirm="handleDialogConfirm"
      @cancel="handleDialogCancel"
    />
  </div>
</template>

<script>
import CustomDialog from '../common/CustomDialog.vue';
import {
  buildNavGrid,
  normalizeNavItem,
  cacheAggregateChildren,
  prepareGiftMallSource,
  isAggregateRoute,
  resolveCategoryRoute,
  shouldOpenEntrance,
  navigateToGoodsList,
  markHomeLeaveForH5,
} from '@/utils/categoryNav';

export default {
  name: "NavImage",
  props: {
    cardShowFlag: {
      type: String | Number,
      default: null
    },
  },
  data() {
    return {
      duration: 500,
      current: 0,
      reqCategory: [],
      bottomCategory: [],
      formatCategory: [],
      showCustomDialog: false,
      dialogMessage: '',
      currentJumpPageFlag: '',
    };
  },
  components: {
    CustomDialog
  },
  methods: {
    setIndex() {
      if (this.current > 0 && this.$refs.mySwipe) {
        this.duration = 0
        this.$refs.mySwipe.swipeTo(this.current);
      }
      var timer = setInterval(() => {
        this.duration = 500
        clearInterval(timer);
      }, 200)
    },

    /** 恢复分类 swipe 页码（由 Home.restoreHomeViewState 在数据就绪后统一触发） */
    applySwipeIndex(swipeIndex = 0) {
      const index = parseInt(swipeIndex, 10);
      if (Number.isNaN(index) || index <= 0) {
        return;
      }
      this.current = index;
      const tryApply = (attempt = 0) => {
        this.$nextTick(() => {
          if (this.$refs.mySwipe) {
            this.setIndex();
            return;
          }
          if (attempt < 10) {
            setTimeout(() => tryApply(attempt + 1), 60 * (attempt + 1));
          }
        });
      };
      tryApply();
    },

    onChange(index) {
      this.current = index;
    },
    checkActive(index) {
      return index === this.current;
    },
    async init() {
      const res = await this.$api.queryHomePageCategory(
        localStorage.getItem("bathId"),
        localStorage.getItem("upgradeFlag"),
        localStorage.getItem("cityCode")
      );
      if (!res || !res.data) {
        return;
      }
      const navItems = buildNavGrid(res.data.navItems || [], 25);
      this.formatCategory = navItems.slice(0, 5);
      this.bottomCategory = [
        [navItems.slice(5, 10), navItems.slice(10, 15)],
        [navItems.slice(15, 20), navItems.slice(20, 25)]
      ];
      this.reqCategory = res.data.categoryList || [];
    },
    findCategoryContext(item) {
      if (item.navLevel === 2 && item.parentId) {
        const parent = (this.reqCategory || []).find(c => c.id === item.parentId);
        return { parent, children: parent ? parent.children : [] };
      }
      const self = (this.reqCategory || []).find(c => c.id === item.id);
      return { parent: self, children: self ? self.children : [] };
    },
    goClass(record) {
      const item = normalizeNavItem(record);
      if (!item) {
        return;
      }
      const path = resolveCategoryRoute(item);
      if (path) {
        if (path === '/GiftPackageHome') {
          prepareGiftMallSource();
        }
        if (isAggregateRoute(path)) {
          const ctx = this.findCategoryContext(item);
          const navRoute = item.navRoute || (ctx.parent && ctx.parent.navRoute);
          cacheAggregateChildren(navRoute, ctx.children);
          this.$router.push({ path, query: { title: item.name } });
          return;
        }
        this.$router.push({ path, query: { indexName: item.name } });
        return;
      }
      if (shouldOpenEntrance(item)) {
        if (item.jumpPageFlag === 'mt_maicai') {
          this.currentJumpPageFlag = item.jumpPageFlag;
          this.dialogMessage = '本资源由第三方合作平台提供服务，将依据每笔订单的点数收取第三方平台服务费，具体点数以支付时页面提示为准。<br/><br/>感谢您的理解与支持，祝您购物愉快！';
          this.showCustomDialog = true;
          return;
        }
        this.$api.getEntrance(item.jumpPageFlag).then((res) => {
          if (res.code === 0) {
            markHomeLeaveForH5(this.current);
            window.location.href = res.data;
          } else {
            this.$Toast.fail(res.msg)
          }
        }).catch((err) => {
          console.log(err);
        });
        return;
      }
      navigateToGoodsList(this, item);
    },

    handleDialogConfirm() {
      if (this.currentJumpPageFlag) {
        this.$api.getEntrance(this.currentJumpPageFlag)
          .then(res => {
            if (res.code === 0) {
              markHomeLeaveForH5(this.current);
              window.location.href = res.data;
            } else {
              this.$Toast.fail(res.msg)
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.showCustomDialog = false;
      this.currentJumpPageFlag = '';
    },

    handleDialogCancel() {
      this.showCustomDialog = false;
      this.currentJumpPageFlag = '';
    },
  },
  mounted() {
  },
  watch: {
    '$route': function () {
      this.setIndex()
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  border-radius: 0.5rem;
  background: #ffffff;
  width: 100%;
  padding: 0.625rem 0.25rem 0.375rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;

  .container {
    margin-bottom: 0;
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    >div {
      margin-bottom: 0;
    }

    .img {
      width: 2.75rem;
      height: 2.75rem;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .imageDiv--compact {
    justify-content: flex-start;
    gap: 0.5rem 1.25rem;
    padding: 0 0.5rem;

    .imageDivItem {
      width: auto;
      flex: 0 0 auto;
    }
  }

  .container2 {
    width: 100%;

    >div {
      margin: 2px 0;
    }

    .img {
      width: 2.75rem;
      height: 2.75rem;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}

.category-swipe-wrap {
  padding-bottom: 0.25rem;
}

.category-swipe {
  height: 100%;
}

.category-swipe-page {
  display: flex;
  flex-direction: column;
}

.indicators {
  position: absolute;
  bottom: 2px;
  left: 50%;
  display: flex;
  transform: translateX(-50%);

  .indicator {
    width: 3px;
    height: 3px;
    background-color: #c90c0c;
    border-radius: 50%;
    opacity: 0.4;
    transition: opacity 0.5s, background-color 0.5s;

    &:not(:last-child) {
      margin-right: 4px;
      margin-top: 5px;
    }

    &:last-child {
      margin-right: 4px;
      margin-top: 5px;
    }

    &.active {
      width: 10px;
      height: 3px;
      border-radius: 2px;
      opacity: 0.8;
    }
  }
}

.divText {
  font-size: 0.75rem;
  color: #222;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  margin-top: 0.3rem;
  line-height: 1.35;
  width: 100%;
  max-width: 100%;
  padding: 0 0.125rem;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
}

.imageDivItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20%;
  padding: 0.125rem 0;
  box-sizing: border-box;
}
</style>
